/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../../constants';
const elementName = `${COMPONENT_NAME_PREFIX}deprecated-button`;
const attributes = {
    TYPE: 'type',
    DISABLED: 'disabled',
    FULL_WIDTH: 'full-width'
};
const selectors = {
    BUTTON: 'button,a'
};
export const DEPRECATED_BUTTON_CONSTANTS = {
    elementName,
    attributes,
    selectors
};
